import React from 'react';
import { caesareaImage } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-night-deep px-5 pb-12 pt-20" aria-labelledby="problema-titulo" data-id="element-165" data-mp="2lstjzhrrqcfl">
      <div className="mx-auto max-w-5xl" data-id="element-166" data-mp="30hprndpwxnfo">
        <h2 id="problema-titulo" className="mx-auto max-w-3xl text-center font-display text-2xl font-bold leading-snug text-cream md:text-4xl" data-id="element-167" data-mp="30isixmr5drw4">
          ¿Cuántas veces has leído esto sin saber dónde ocurrió?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-cream-dim md:text-lg" data-id="element-168" data-mp="35gtyvyta1b3d">
          La Biblia menciona cientos de lugares reales — Betel, Efraín, Capernaum, Jope — pero sin verlos pierdes el
          contexto de la historia. Leer sin ubicar es leer solo la mitad del mensaje.
        </p>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-169" data-mp="1p33vku9zequs">
          <article className="flex flex-col rounded-xl border border-night-line bg-night-soft p-6" data-id="element-170" data-mp="1k2y0130lck7f">
            <p className="font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-cream-dim" data-id="element-171" data-mp="jddecdssymy6">
              Solo texto
            </p>
            <blockquote className="mt-5 text-lg italic leading-relaxed text-cream" data-id="element-172" data-mp="ocpzmu40zlyn">
              «Salió Jesús con sus discípulos por las aldeas de Cesarea de Filipo. Y en el camino les preguntó: ¿Quién
              dicen los hombres que soy yo?»
            </blockquote>
            <cite className="mt-4 block not-italic text-sm text-gold" data-id="element-173" data-mp="124eaku2jg4e1">— Marcos 8:27</cite>
            <p className="mt-auto pt-6 text-sm leading-relaxed text-cream-dim" data-id="element-174" data-mp="1726buep2p2uw">
              ¿Dónde queda Cesarea de Filipo? ¿Qué camino tomaron? El pasaje queda en el aire.
            </p>
          </article>

          <article className="flex flex-col rounded-xl border border-gold/40 bg-night-card p-6" data-id="element-175" data-mp="1g3noto76oofd">
            <p className="font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-176" data-mp="3dtxcbmbggs83">
              Con mapa 3D
            </p>
            <blockquote className="mt-5 text-lg italic leading-relaxed text-cream" data-id="element-177" data-mp="3hwts759m2a8c">
              «Salió Jesús con sus discípulos por las aldeas de Cesarea de Filipo…»
            </blockquote>
            <img src={caesareaImage} alt="Cesarea de Filipo — reconstrucción 3D" className="mt-auto w-full rounded-lg border border-night-line pt-0" loading="lazy" data-id="element-178" data-mp="k30jhsljj8ec" />
          </article>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-lg leading-relaxed text-gold md:text-xl" data-id="element-179" data-mp="17y37xzgfn9ua">
          La diferencia entre leer y entender es ver el escenario donde todo sucedió.
        </p>
      </div>
    </section>;
}